import { FC } from 'react';
import ChevronDown from 'images/icons/ChevronDown.svg?react';
import ChevronUp from 'images/icons/ChevronUp.svg?react';
import { SSortIcon, SortDirection } from './styles';

type SortIconProps = {
    // Direction de tri active de la colonne ; `null` = colonne triable mais non triée.
    direction?: SortDirection;
};

// Icône indiquant qu'une colonne est triable : chevrons haut/bas empilés.
const SortIcon: FC<SortIconProps> = ({ direction = null }) => (
    <SSortIcon $direction={direction}>
        <ChevronUp className="sort-up" />
        <ChevronDown className="sort-down" />
    </SSortIcon>
);

export default SortIcon;
